module.exports = __webpack_public_path__ + "../resources/img/ic_globe.49edbda9.svg";